export enum ACCESS_CONTROL_TYPES {
    // perfil
    ROLE_PERFIL_READ = "ROLE_PERFIL_READ",
    ROLE_MARGIN_EDIT = "ROLE_MARGIN_EDIT",

    // dashboard
    ROLE_DASHBOARD_READ = "ROLE_DASHBOARD_READ",

    // cadastro
    ROLE_REGISTER_READ = "ROLE_REGISTER_READ",

    ROLE_USERS_READ = "ROLE_USERS_READ",
    ROLE_USERS_CREATE = "ROLE_USERS_CREATE",
    ROLE_USERS_UPDATE = "ROLE_USERS_UPDATE",
    ROLE_USERS_DELETE = "ROLE_USERS_DELETE",

    ROLE_CUSTOMERS_READ = "ROLE_CUSTOMERS_READ",
    ROLE_CUSTOMERS_CREATE = "ROLE_CUSTOMERS_CREATE",
    ROLE_CUSTOMERS_UPDATE = "ROLE_CUSTOMERS_UPDATE",
    ROLE_CUSTOMERS_DELETE = "ROLE_CUSTOMERS_DELETE",

    ROLE_VEHICLES_READ = "ROLE_VEHICLES_READ",
    ROLE_VEHICLES_CREATE = "ROLE_VEHICLES_CREATE",
    ROLE_VEHICLES_UPDATE = "ROLE_VEHICLES_UPDATE",
    ROLE_VEHICLES_DELETE = "ROLE_VEHICLES_DELETE",

    ROLE_PRODUCTS_READ = "ROLE_PRODUCTS_READ",
    ROLE_PRODUCTS_CREATE = "ROLE_PRODUCTS_CREATE",
    ROLE_PRODUCTS_UPDATE = "ROLE_PRODUCTS_UPDATE",
    ROLE_PRODUCTS_DELETE = "ROLE_PRODUCTS_DELETE",

    // escritório
    ROLE_DESK_READ = "ROLE_DESK_READ",

    // documentos do sistema
    ROLE_SYSTEM_DOCS_READ = "ROLE_SYSTEM_DOCS_READ",
    ROLE_SYSTEM_DOCS_CREATE = "ROLE_SYSTEM_DOCS_CREATE",
    ROLE_SYSTEM_DOCS_UPDATE = "ROLE_SYSTEM_DOCS_UPDATE",
    ROLE_SYSTEM_DOCS_DELETE = "ROLE_SYSTEM_DOCS_DELETE",
};
